import script from "./HobbiesView.vue?vue&type=script&setup=true&lang=js"
export * from "./HobbiesView.vue?vue&type=script&setup=true&lang=js"

import "./HobbiesView.vue?vue&type=style&index=0&id=dcc4197e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcc4197e"]])

export default __exports__